module.exports = __webpack_public_path__ + "img/edit-pen-rectangle.5696eef3.svg";